import { Box } from '@hivebrite/design-system/Box';
import { CardWithTitle } from '@hivebrite/design-system/Card';

import {
  Email,
  Text,
} from 'hb-react/shared/components/formik/components/inputs';

const PersonalInformation = ({ userFieldsConfig }) => (
  <CardWithTitle title={s__('NetworkEvents|Personal information')}>
    <Box
      display="grid"
      gridTemplateColumns={{
        _: '1fr',
        m: '1fr 1fr',
      }}
      style={{ gap: '24px' }}
    >
      <Text
        name="receipt[firstname]"
        label={
          userFieldsConfig?.firstname_label ||
          I18n.t('activerecord.attributes.user.firstname')
        }
        placeholder={
          userFieldsConfig?.firstname_placeholder ||
          I18n.t('activerecord.attributes.user.firstname')
        }
        validate={{ required: true }}
        wrapperProps={{ mb: 0 }}
      />
      <Text
        name="receipt[lastname]"
        label={
          userFieldsConfig?.lastname_label ||
          I18n.t('activerecord.attributes.user.lastname')
        }
        placeholder={
          userFieldsConfig?.lastname_placeholder ||
          I18n.t('activerecord.attributes.user.lastname')
        }
        validate={{ required: true }}
        wrapperProps={{ mb: 0 }}
      />
      <Email
        name="receipt[email]"
        label={
          userFieldsConfig?.email_label ||
          I18n.t('activerecord.attributes.user.email')
        }
        placeholder={
          userFieldsConfig?.email_placeholder ||
          I18n.t('activerecord.attributes.user.email')
        }
        validate={{ required: true }}
        wrapperProps={{ mb: 0 }}
      />
    </Box>
  </CardWithTitle>
);

export default PersonalInformation;
